import { useMutation } from '@tanstack/react-query';
import { adminServices } from '../../../Domain/Admin/Services';
import type { BulkLeftCompanyEmployee } from '../../../Domain/Admin/Services';

const mutationFn = (employees: BulkLeftCompanyEmployee[]) => {
  return adminServices.bulkLeftCompanyBackup(employees);
};

export const useBulkLeftCompanyBackupMutation = () => {
  return useMutation<
    Awaited<ReturnType<typeof adminServices.bulkLeftCompanyBackup>>,
    unknown,
    BulkLeftCompanyEmployee[]
  >(mutationFn);
};
